import { Component, OnInit, input } from '@angular/core';

@Component({
    selector: 'app-preloader',
    templateUrl: './preloader.component.html',
    styleUrls: ['./preloader.component.scss'],
    standalone: true
})
export class PreloaderComponent implements OnInit {

  readonly color = input('#fff');
  readonly id = input(Date.now());

  constructor() { }

  ngOnInit() {
  }

}
